const environment = process.env.REACT_APP_ENV;

let apiLocation = '';

if (!environment || environment === 'local') {
    // Local Development API.
    apiLocation = 'https://localhost:44316/api';
} else if (environment === 'staging') {
    // Staging API.
    apiLocation = 'https://blazestaging.truebyte.co.uk/api';
} else if (environment === 'production') {
    // Production API.
    apiLocation = 'https://blaze.truebyte.co.uk/api';
}

console.log('environment:', environment, apiLocation);

export const config = {
    apiUrl: apiLocation,
    supportInbox: 'Blaze@truebyte.co.uk'
}